import { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

/** The standard empty state: centered icon + title + optional description/action. */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-2 py-12 text-center",
        className,
      )}
    >
      {Icon && <Icon className="text-muted-foreground/40 h-10 w-10" />}
      <p className="font-medium">{title}</p>
      {description && (
        <p className="text-muted-foreground text-sm">{description}</p>
      )}
      {action}
    </div>
  );
}
